import { ChangeEvent, useState } from 'react';
import { connect } from 'react-redux';
import { IStore } from '../../store/reducers/store.d';
import { useTranslation } from 'react-i18next';
import { BaseBox, BaseFont } from '../../shared/constants/theme';
import * as SC from './Styles';
import { postFeedback } from '../../api/fetchCalls';
import i18next from 'i18next';
import {
    IForm,
    IFormRadioOptions,
    IPostRequestPayloadFeedBack,
} from './FeedbackForm.d';
import { FormSubmitButton } from './Styles';

const FeedbackForm = (props: IForm) => {
    const { t } = useTranslation();
    const {
        feedbackRes,
        goToSuccessPage,
        atm: { BasicData },
    } = props;

    const [inputValue, setInputValue] = useState('');

    const [activeRadioItemKey, setActiveRadioItemKey] = useState('');

    const radioButtonHandler = (event: ChangeEvent<HTMLInputElement>) => {
        event.persist();
        setActiveRadioItemKey(event.target.id);
        setInputValue('');
    };

    const submitForm = () => {
        const feedback: IPostRequestPayloadFeedBack = {
            id: '',
            textField: '',
        };
        const radioElement = document.querySelector(
            'input[name="radioFeedbacksList"]:checked'
        ) as HTMLInputElement;
        if (radioElement) {
            feedback.id = radioElement.value;
        }
        if (inputValue.length !== 0) {
            feedback.textField = inputValue;
        }

        //---------create post object-----------

        goToSuccessPage();
        postFeedback(i18next.language, { BasicData, feedback });
    };

    return (
        <>
            <SC.OptionsContainer data-testid="radio-button-container">
                {feedbackRes.data.map((key: IFormRadioOptions) => {
                    return (
                        <BaseFont key={key.id} as="div" size={300}>
                            <BaseBox bottom={3}>
                                <SC.RadioContainer>
                                    <label
                                        className="containerRadio"
                                        title={key.value}
                                        aria-label={key.value}
                                    >
                                        <p>{key.value}</p>
                                        <input
                                            type="radio"
                                            id={key.id}
                                            name="radioFeedbacksList"
                                            value={key.id}
                                            onChange={radioButtonHandler}
                                            data-testid={`radio-item-${key.id}`}
                                        />
                                        <span className="check" />
                                    </label>
                                </SC.RadioContainer>
                            </BaseBox>
                        </BaseFont>
                    );
                })}
            </SC.OptionsContainer>
            <BaseBox top={3} bottom={3}>
                <FormSubmitButton
                    onClick={submitForm}
                    disabled={!activeRadioItemKey}
                    data-testid="feedback-form-submit"
                    alt={t('submitFeedback')}
                    title={t('submitFeedback')}
                    aria-label={t('submitFeedback')}
                    aria-labelledby={t('submitFeedback')}
                >
                    {t('submitFeedback')}
                </FormSubmitButton>
            </BaseBox>
        </>
    );
};

const mapStateToProps = (state: IStore) => {
    return {
        atm: state.detailedAtm,
    };
};

export default connect(mapStateToProps, null)(FeedbackForm);
